import React from "react";
import { SnakeGame } from "./SnakeGame.tsx";

interface LoadingOverlayProps {
  message: string;
}

/**
 * Full-screen modal overlay shown while a long-running AI/network call is
 * in flight. Renders the SnakeGame so the user has something to do while
 * they wait.
 */
export function LoadingOverlay({ message }: LoadingOverlayProps) {
  return (
    <div className="modal-overlay">
      <div
        className="modal"
        style={{
          maxWidth: "420px",
          textAlign: "center",
        }}
      >
        <p style={{ margin: "0 0 12px 0", fontSize: "14px" }}>{message}</p>
        <SnakeGame />
      </div>
    </div>
  );
}
